import ContentList from '@chipsadesign/content-list';
import ContentListFilter from '@chipsadesign/content-list/dist/modules/ContentListFilter';
import { lazyload } from './lazyload';
import revealInit from './reveal';
import initSelects from './selects';
import priceFilters from './price-filters';
import initPreviewSwitch from './preview-switch';

export default function initContentList() {
    const catalogEl = document.querySelector('.js-catalog');
    const filterContainer = document.querySelector('.js-catalog-filter');

    if (catalogEl) {
        const loadMoreButton = document.querySelector('.js-load-more-button');

        new ContentList(catalogEl, {
            modules: filterContainer ? [ContentListFilter] : [],
            // Параметры
            filter: filterContainer
                ? {
                    el: filterContainer,
                    filterOnInputChange: true,
                    inputDebounceTime: 1000,
                }
                : null,
            onFetchSuccess: (instance, response) => {
                if (response.data.method === 'append') {
                    instance.contentEl.innerHTML += response.data.contentHtml;
                } else if (response.data.method === 'insert') {
                    instance.contentEl.innerHTML = response.data.contentHtml;
                }

                if (response.data.filterHtml && filterContainer) {
                    filterContainer.innerHTML = response.data.filterHtml;
                    initSelects(filterContainer);
                    priceFilters();
                }

                lazyload.update();
                revealInit(catalogEl);
                initPreviewSwitch();

                if (response.data.nextEndpoint && loadMoreButton) {
                    loadMoreButton.setAttribute('href', response.data.nextEndpoint);
                    loadMoreButton.style.display = '';
                }
                if (!response.data.nextEndpoint && loadMoreButton) {
                    loadMoreButton.style.display = 'none';
                }
            },
        });
    }
}
